const LISTINGS_CACHE_KEY = "365_listings_cache_v1";
const LISTINGS_CACHE_TTL_MS = 10 * 60 * 6000; // 1 hour

export const readListingsCache = () => {
  try {
    const raw = localStorage.getItem(LISTINGS_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.data) || !parsed.timestamp) {
      return null;
    }
    if (Date.now() - parsed.timestamp > LISTINGS_CACHE_TTL_MS) {
      return null;
    }
    return parsed.data;
  } catch (error) {
    return null;
  }
};

export const writeListingsCache = (data) => {
  try {
    if (!Array.isArray(data)) return;
    const payload = {
      timestamp: Date.now(),
      data,
    };
    localStorage.setItem(LISTINGS_CACHE_KEY, JSON.stringify(payload));
  } catch (error) {
    // Ignore cache write errors
  }
};
